(() => {
  const section = document.querySelector('[data-aonsk-contact]');
  if (!section) return;

  const topicRadios = Array.from(section.querySelectorAll('[data-contact-topic-radio]'));
  const submitButton = section.querySelector('[data-contact-submit]');
  const form = submitButton ? submitButton.closest('form') : null;
  const orderGroup = section.querySelector('[data-contact-group="order"]');
  const growingGroup = section.querySelector('[data-contact-group="growing"]');
  const technicalGroup = section.querySelector('[data-contact-group="technical"]');
  const partnershipGroup = section.querySelector('[data-contact-group="partnership"]');
  const orderNumber = section.querySelector('[data-order-number]');
  const topicNotes = Array.from(section.querySelectorAll('[data-contact-note]'));

  const orderTopics = new Set(['order', 'return']);
  const growingTopics = new Set(['seed', 'growing']);
  const technicalTopics = new Set(['website']);
  const partnershipTopics = new Set(['partnership']);
  const validTopics = new Set(['order', 'return', 'seed', 'growing', 'store', 'partnership', 'website', 'other']);

  const selectedTopicKey = () => topicRadios.find((radio) => radio.checked)?.dataset.contactTopicRadio || '';

  const selectTopicByKey = (key) => {
    if (!validTopics.has(key)) return false;
    const radio = topicRadios.find((item) => item.dataset.contactTopicRadio === key);
    if (!radio) return false;
    radio.checked = true;
    return true;
  };

  const setGroupState = (group, active) => {
    if (!group) return;
    group.classList.toggle('is-active', active);
    group.setAttribute('aria-hidden', active ? 'false' : 'true');
    group.querySelectorAll('input, select, textarea').forEach((field) => {
      field.disabled = !active;
    });
  };

  const updateTopic = (topicKey) => {
    const key = validTopics.has(topicKey) ? topicKey : '';
    section.dataset.activeContactTopic = key;

    setGroupState(orderGroup, orderTopics.has(key));
    setGroupState(growingGroup, growingTopics.has(key));
    setGroupState(technicalGroup, technicalTopics.has(key));
    setGroupState(partnershipGroup, partnershipTopics.has(key));

    if (orderNumber) {
      orderNumber.required = false;
      orderNumber.setAttribute('aria-required', orderNumber.required ? 'true' : 'false');
    }

    topicNotes.forEach((note) => {
      note.hidden = note.dataset.contactNote !== key;
    });
  };

  topicRadios.forEach((radio) => {
    radio.addEventListener('change', () => updateTopic(selectedTopicKey()));
  });

  const params = new URLSearchParams(window.location.search);
  const requestedTopic = params.get('topic');
  if (requestedTopic) selectTopicByKey(requestedTopic);
  updateTopic(selectedTopicKey());

  if (params.get('open') === 'form') {
    window.requestAnimationFrame(() => {
      document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => {
        const selected = topicRadios.find((radio) => radio.checked) || topicRadios[0];
        selected?.focus({ preventScroll: true });
      }, 500);
    });
  }

  const searchInput = section.querySelector('[data-contact-search]');
  const searchClear = section.querySelector('[data-contact-search-clear]');
  const searchStatus = section.querySelector('[data-contact-search-status]');
  const searchEmpty = section.querySelector('[data-contact-search-empty]');
  const searchableItems = Array.from(section.querySelectorAll('[data-contact-search-item]'));

  const normalizeSearch = (value) => value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const filterHelp = (rawQuery) => {
    const query = normalizeSearch(rawQuery);
    let routeMatches = 0;
    let faqMatches = 0;

    searchableItems.forEach((item) => {
      const haystack = normalizeSearch(item.dataset.contactSearchText || item.textContent || '');
      const matches = !query || query.split(' ').every((term) => haystack.includes(term));
      item.hidden = !matches;
      if (matches && query) {
        if (item.classList.contains('aonsk-contact__route-card')) routeMatches += 1;
        if (item.classList.contains('aonsk-contact__faq-item')) faqMatches += 1;
      }
    });

    if (searchClear) searchClear.hidden = !query;
    if (searchEmpty) searchEmpty.hidden = !query || routeMatches + faqMatches > 0;

    if (searchStatus) {
      if (!query) {
        searchStatus.textContent = section.dataset.searchIdle;
      } else if (routeMatches + faqMatches === 0) {
        searchStatus.textContent = section.dataset.searchEmpty;
      } else {
        const count = routeMatches + faqMatches;
        searchStatus.textContent = count === 1
          ? section.dataset.searchOne
          : section.dataset.searchMany.replace('[count]', String(count));
      }
    }
  };

  if (searchInput) {
    searchInput.addEventListener('input', () => filterHelp(searchInput.value));
    searchClear?.addEventListener('click', () => {
      searchInput.value = '';
      filterHelp('');
      searchInput.focus();
    });
  }

  section.querySelectorAll('[data-contact-topic-link]').forEach((link) => {
    link.addEventListener('click', () => {
      const topic = link.dataset.contactTopicLink;
      if (!selectTopicByKey(topic)) return;
      updateTopic(topic);
      window.setTimeout(() => {
        topicRadios.find((radio) => radio.checked)?.focus({ preventScroll: true });
      }, 400);
    });
  });

  if (form && submitButton) {
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      submitButton.disabled = true;
      submitButton.textContent = section.dataset.sending;

      window.setTimeout(() => {
        submitButton.disabled = false;
        submitButton.textContent = section.dataset.send;
      }, 12000);
    });
  }
})();

